import React from 'react';
import Navbar from './Navbar';
import './DemoPage.css';

export default function DemoPage() {
  return (
    <div className="demo-page">
      <Navbar />

      {/* ── Logo header ──────────────────────────────────────────────── */}
      <div className="demo-logo-section">
        <img
          src={`${process.env.PUBLIC_URL}/images/logo.png`}
          alt="Eye2Voice"
          className="demo-logo"
        />
      </div>

      <div className="demo-container">

        {/* ── Hero heading ─────────────────────────────────────────────── */}
        <section className="demo-hero">
          <h1 className="demo-heading">Demo Eye2Voice</h1>
          <p className="demo-subheading">
            Below see how our application works in detail
          </p>
        </section>

        {/* ── Main demo block ───────────────────────────────────────────── */}
        <div className="demo-main-block">
          {/* Desktop & tablet */}
          <video
            className="demo-main-video demo-main-video--desktop"
            src={`${process.env.PUBLIC_URL}/images/demo.mp4`}
            controls
            playsInline
            aria-label="Eye2Voice demo video"
          />
          {/* Mobile */}
          <video
            className="demo-main-video demo-main-video--mobile"
            src={`${process.env.PUBLIC_URL}/images/mobile-demo.mov`}
            controls
            playsInline
            aria-label="Eye2Voice demo video"
          />
        </div>

        {/* ── Feature rows ──────────────────────────────────────────────── */}
        <section className="demo-features">

          {/* Row 1 — text left, image right */}
          <div className="demo-row demo-row--text-left">
            <div className="demo-row-content">
              <h2 className="demo-feature-heading">Calibration Screen</h2>
              <p className="demo-feature-body">
                To help ensure the application works for people in different
                positions or with more limited mobility there is a one time
                calibration screen that happens with each session.
              </p>
            </div>
            <div className="demo-row-media">
              <video
                src={`${process.env.PUBLIC_URL}/images/calibration.mov`}
                autoPlay
                loop
                muted
                playsInline
                aria-label="Calibration screen demo"
              />
            </div>
          </div>

          {/* Row 2 — image left, text right */}
          <div className="demo-row demo-row--image-left">
            <div className="demo-row-media">
              <img
                src={`${process.env.PUBLIC_URL}/images/website/customization.png`}
                alt="Eye2Voice customization settings"
              />
            </div>
            <div className="demo-row-content">
              <h2 className="demo-feature-heading">Customization</h2>
              <p className="demo-feature-body">
                There is no one-size fits all accessible application. We've
                built features to help make this application work for anything,
                anywhere.
              </p>
            </div>
          </div>

        </section>

        {/* ── Three pillars ─────────────────────────────────────────────── */}
        <section className="demo-pillars">
          <div className="demo-pillar">
            <h3 className="demo-pillar-label">Reliable</h3>
            <p className="demo-pillar-body">
              Reliably use a gaze detection model to identify when a user is
              looking: Up — Down — Left — Right
            </p>
          </div>
          <div className="demo-pillar">
            <h3 className="demo-pillar-label">Lightweight</h3>
            <p className="demo-pillar-body">
              Ability to work anywhere, on any device — with little to no setup
              required
            </p>
          </div>
          <div className="demo-pillar">
            <h3 className="demo-pillar-label">Impactful</h3>
            <p className="demo-pillar-body">
              Affordable and effortless — so more people can actually use it
              and feel empowered
            </p>
          </div>
        </section>

      </div>

      {/* ── Footer ───────────────────────────────────────────────────── */}
      <footer className="demo-footer">
        <p className="footer-text">
          UC Berkeley Masters of Information and Data Science Capstone Project
        </p>
        <a className="footer-email" href="mailto:eyetovoice@gmail.com">
          eyetovoice@gmail.com
        </a>
      </footer>
    </div>
  );
}
